

import { useEffect, useState } from "react";
import { Box, Menu, MenuItem } from "@mui/material";
import { FiSearch } from 'react-icons/fi';
import axios from 'axios';
import { TableBody, TablePagination, Typography } from '@mui/material';
import { Button, Col, Form, Dropdown, Row, Container } from "react-bootstrap";
import Paper from "@mui/material/Paper";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const SalesReport = () => {
  const [ttowerno, setTowardsTowerNumber] = useState('');
  const [responset, setResponset] = useState([]);
  const [filterInput, setFilterInput] = useState('');
  const [prname, setPrName] = useState('');
  const [projectName, setProjectName] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [viewMode, setViewMode] = useState('Full View'); 
  const [vPrname,setVPrname]=useState('');
  const [projectNameVilla, setProjectNameVilla] = useState([]);// Added state for view mode

  const [selectedColumns, setSelectedColumns] = useState([
    { id: 'customerName', label: 'Customer Name', width: 150, isVisible: true },
    { id: 'email', label: 'Email', width: 200, isVisible: true },
    { id: 'flatNo', label: 'Villa No', width: 200, isVisible: true },
    // { id: 'floor', label: 'Floor', width: 160, isVisible: true },
    { id: 'installment1', label: 'Installment 1', width: 150, isVisible: true },
    { id: 'installment2', label: 'Installment 2', width: 150, isVisible: true },
    { id: 'installment3', label: 'Installment 3', width: 150, isVisible: true },
    { id: 'installment4', label: 'Installment 4', width: 150, isVisible: true },
    { id: 'installment5', label: 'Installment 5', width: 150, isVisible: true },
    { id: 'installment6', label: 'Installment 6', width: 150, isVisible: true },
    { id: 'installment7', label: 'Installment 7', width: 150, isVisible: true },
    { id: 'installment8', label: 'Installment 8', width: 150, isVisible: true },
    { id: 'installment9', label: 'Installment 9', width: 150, isVisible: true },
    { id: 'installment10', label: 'Installment 10', width: 150, isVisible: true },
    { id: 'invoice1', label: 'Invoice 1', width: 120, isVisible: true },
    { id: 'invoice2', label: 'Invoice 2', width: 120, isVisible: true },
    { id: 'invoice3', label: 'Invoice 3', width: 120, isVisible: true },
    { id: 'invoice4', label: 'Invoice 4', width: 120, isVisible: true },
    { id: 'invoice5', label: 'Invoice 5', width: 120, isVisible: true },
    { id: 'invoice6', label: 'Invoice 6', width: 120, isVisible: true },
    { id: 'invoice7', label: 'Invoice 7', width: 120, isVisible: true },
    { id: 'invoice8', label: 'Invoice 8', width: 120, isVisible: true },
    { id: 'invoice9', label: 'Invoice 9', width: 120, isVisible: true },
    { id: 'invoice10', label: 'Invoice 10', width: 120, isVisible: true },
    { id: 'balance1', label: 'Balance 1', width: 150, isVisible: true },
    { id: 'balance2', label: 'Balance 2', width: 150, isVisible: true },
    { id: 'balance3', label: 'Balance 3', width: 150, isVisible: true },
    { id: 'balance4', label: 'Balance 4', width: 150, isVisible: true },
    { id: 'balance5', label: 'Balance 5', width: 150, isVisible: true },
    { id: 'balance6', label: 'Balance 6', width: 150, isVisible: true },
    { id: 'balance7', label: 'Balance 7', width: 150, isVisible: true },
    { id: 'balance8', label: 'Balance 8', width: 150, isVisible: true },
    { id: 'balance9', label: 'Balance 9', width: 150, isVisible: true },
    { id: 'balance10', label: 'Balance 10', width: 150, isVisible: true },
    { id: 'date1', label: 'Date 1', width: 130, isVisible: true },
    { id: 'date2', label: 'Date 2', width: 130, isVisible: true },
    { id: 'date3', label: 'Date 3', width: 130, isVisible: true },
    { id: 'date4', label: 'Date 4', width: 130, isVisible: true },
    { id: 'date5', label: 'Date 5', width: 130, isVisible: true },
    { id: 'date6', label: 'Date 6', width: 130, isVisible: true },
    { id: 'date7', label: 'Date 7', width: 130, isVisible: true },
    { id: 'date8', label: 'Date 8', width: 130, isVisible: true },
    { id: 'date9', label: 'Date 9', width: 130, isVisible: true },
    { id: 'date10', label: 'Date 10', width: 130, isVisible: true },
    { id: 'loan', label: 'Loan', width: 100, isVisible: true },
    { id: 'tower', label: 'Tower', width: 150, isVisible: true },
    { id: 'ucin', label: 'UCIN', width: 100, isVisible: true },
    { id: 'totalValue', label: 'Total Value', width: 150, isVisible: true },
  ]);

  const [selectedColumnIds, setSelectedColumnIds] = useState(selectedColumns.filter(col => col.isVisible).map(col => col.id));

  useEffect(() => {
    const updatedColumns = selectedColumns.map(col => ({
      ...col,
      isVisible: viewMode === 'Full View' ? true : selectedColumnIds.includes(col.id)
    }));
    setSelectedColumns(updatedColumns);
  }, [viewMode, selectedColumnIds]);

  useEffect(() => {
    // Reset column visibility when the tower changes or view mode changes
    if (viewMode === 'Full View') {
      setSelectedColumns(cols =>
        cols.map(col => ({ ...col, isVisible: true }))
      );
    }
  }, [ttowerno, viewMode]);

  const handleColumnToggle = (columnId) => {
    const updatedColumns = selectedColumns.map(col =>
      col.id === columnId ? { ...col, isVisible: !col.isVisible } : col
    );
    setSelectedColumns(updatedColumns);
  };


  
  useEffect(()=>{
    getVillaProjectNames()
  },[])

  // const getFloor = () => {
  //   axios
  //     .post('https://buildfastapi.kollagroup.in/project/api/v1/towers-getall')
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setResponset(res.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching floor data:', error);
  //     });
  // };

  // const getProjectNames = () => {
  //   axios
  //     .get('https://buildfastapi.kollagroup.in/project/api/v1/get-basic')
  //     .then((res) => {
  //       setProjectName(res.data.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // useEffect(() => {
  //   getFloor();
  //   getProjectNames();
  // }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://buildfastvapi.emedha.in/create-customer/api/v1/get-sales-data?ProjectName=${vPrname}`
      );
  
      if (!response.ok) {
        // If response is 404, handle it separately
        if (response.status === 404) {
          const errorData = await response.json(); // Get the message from the 404 response
          alert(errorData.message);  // Display the alert with the error message
          return;  // Exit early if no data found
        }
  
        throw new Error('Failed to fetch data');  // For other errors
      }
  
      const data = await response.json();
  
      // Combine data from the API into one list
      const combinedList = data.billingData.map(billing => {
        const payments = data.paymentData.filter(payment => payment.ucin === billing.ucin);
  
        return {
          ...billing,
          payments: payments.map(payment => ({
            invoice: payment.invoice,
            paidAmount: payment.paidAmount,
            billdate: payment.billdate,
          })),
        };
      });
  
      setCombinedData(combinedList); // Store combined data in state
  
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  
  

  useEffect(() => {
    if (vPrname) {
      fetchData();
    }
  }, [vPrname]);

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
    });

    const columnsPerPage = 10;

    const generateTable = (columns, rows) => {
      doc.autoTable({
        columns: columns.map(col => ({ header: col.label, dataKey: col.id, width: col.width })),
        body: rows,
        margin: { top: 10, left: 10 },
        columnStyles: { 0: { cellWidth: 'auto' } },
      });
    };

    const getVisibleColumns = () => selectedColumns.filter(col => col.isVisible);
    const visibleColumns = getVisibleColumns();
    const numPages = Math.ceil(visibleColumns.length / columnsPerPage);

    const rows = combinedData.map(row => {
      const filteredRow = {};
      visibleColumns.forEach(col => {
        filteredRow[col.id] = row[col.id];
      });
      return filteredRow;
    });

    for (let page = 0; page < numPages; page++) {
      const startColIndex = page * columnsPerPage;
      const endColIndex = Math.min(startColIndex + columnsPerPage, visibleColumns.length);
      const columnsToShow = visibleColumns.slice(startColIndex, endColIndex);

      if (page > 0) {
        doc.addPage();
      }

      generateTable(columnsToShow, rows);
    }

    doc.save('tablepdf.pdf');
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const handleColumnSelection = (colId) => {
    setSelectedColumnIds(prev =>
      prev.includes(colId) ? prev.filter(id => id !== colId) : [...prev, colId]
    );
  };


  const [filteredProjects, setFilteredProjects] = useState([]);

  useEffect(() => {
    const userType = sessionStorage.getItem("userType");
    const projectNames = sessionStorage.getItem("ProjectName");

    // Filter projectNamesss based on userType and ProjectName
    const filtered = projectNameVilla.filter(project => {
      if (userType === "Admin") {
        return project.ProjectName === projectNames;
      }
      return true; // Show all projects for non-admins
    });

    setFilteredProjects(filtered);
  }, [projectNameVilla]);


  const companyId=sessionStorage.getItem("companyId");
  
  const getVillaProjectNames = () => {
    axios
      .get('https://buildfastvapi.emedha.in/project/api/v1/get-basic')
      .then((res) => {
        setProjectNameVilla(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };






  return (
    <>
  {/* Make sure you have imported: import { Box, Typography } from "@mui/material"; */}
{/* Make sure you have imported: import { FiSearch } from "react-icons/fi"; */}

      <Box sx={{ width: "100%" }}>
        
        {/* --- Centered Dashboard Header --- */}
        <Typography 
          sx={{ 
            color: "#1B2559", 
            fontSize: { xs: "24px", md: "28px" }, // Slightly smaller on mobile, larger on desktop
            fontWeight: "800", 
            textAlign: "center", // Centers the text perfectly
            letterSpacing: "-0.5px",
            mb: 3 // Margin bottom to give space before the filter box starts
          }}
        >
           CRM Report
        </Typography>
<Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // Stacks vertically on mobile, horizontally on desktop
    alignItems: { xs: "stretch", md: "flex-end" }, // Aligns the bottoms of the inputs on desktop
    gap: "16px",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E0E5F2",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)",
    width: "100%",
    boxSizing: "border-box",
    mb: 3, // Adds spacing below the filter bar
  }}
>
  {/* 1. Search Filter */}
  <Box > {/* flex: 1 allows it to take up the most space dynamically */}
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Search Filter
    </Typography>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "300px",
        height: "45px", // Standard premium input height
        backgroundColor: "#F4F7FE",
        borderRadius: "8px",
        padding: "0 16px",
        border: "1px solid transparent",
        transition: "all 0.2s ease",
        "&:focus-within": {
          border: "1px solid #4318ff", // Premium purple glow on focus
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 12px rgba(67, 24, 255, 0.05)",
        },
      }}
    >
      <FiSearch style={{ color: "#A3AED0", fontSize: "18px", marginRight: "12px" }} />
      <input
        value={filterInput}
        onChange={(e) => setFilterInput(e.target.value)}
        placeholder="Search..."
        style={{
          width: "100%",
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          fontSize: "14px",
          color: "#2B3674",
          fontWeight: "500",
        }}
      />
    </Box>
  </Box>

  {/* 2. Project Dropdown */}
  <Box sx={{ width: { xs: "100%", md: "250px" } }}> {/* Full width on mobile, 250px on desktop */}
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Project Name
    </Typography>
    <select
      required
      value={vPrname}
      onChange={(e) => setVPrname(e.target.value)}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="">Select Project</option>
      {filteredProjects
        .filter((item) => item.company_id === parseInt(companyId))
        .map((item) => (
          <option key={item.ProjectName} value={item.ProjectName}>
            {item.ProjectName}
          </option>
        ))}
    </select>
  </Box>

  {/* 3. View Mode Dropdown */}
  <Box sx={{ width: { xs: "100%", md: "200px" } }}> {/* Full width on mobile, 200px on desktop */}
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      View Mode
    </Typography>
    <select
      required
      value={viewMode}
      onChange={(e) => setViewMode(e.target.value)}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="Full View">Full View</option>
      <option value="Customized View">Customized View</option>
    </select>
  </Box>
  
</Box>
</Box>
<div style={{ display: "flex", alignItems: "center" }}>
  {viewMode === 'Customized View' && (
    <Dropdown>
      {/* Premium Toggle Button */}
      <Dropdown.Toggle 
        id="dropdown-custom-components"
        style={{
          backgroundColor: "#F4F7FE",
          color: "#4318ff",
          border: "1px solid #E0E5F2",
          borderRadius: "8px",
          height: "45px",
          padding: "0 20px",
          fontWeight: "700",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          boxShadow: "none",
          transition: "all 0.2s ease"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#E9EDF7"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#F4F7FE"}
      >
        Select Columns
      </Dropdown.Toggle>

      {/* Responsive Dropdown Menu */}
      <Dropdown.Menu 
        style={{ 
          width: "600px",       // Optimal width for a desktop view
          maxWidth: "85vw",     // CRITICAL: Prevents it from overflowing on a mobile screen
          minWidth: "280px",    // Ensures it doesn't get too narrow on small phones
          maxHeight: "350px",   // Keeps it from breaking past the bottom of the screen
          overflowY: "auto",    // Enables vertical scrolling for long lists of columns
          overflowX: "hidden",  // Safely disables horizontal scrolling
          padding: "20px",
          borderRadius: "12px",
          border: "1px solid #E0E5F2",
          boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.15)",
          marginTop: "10px",
          zIndex: 9999,         // Ensures the menu pops up ON TOP of your data table
        }}
      >
        {/* Auto-flowing CSS Grid instead of rigid Rows/Cols */}
        <div 
          style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", 
            gap: "15px" 
          }}
        >
          {selectedColumns.map((col) => (
            <Form.Check
              key={col.id}
              type="checkbox"
              id={`checkbox-${col.id}`}
              label={col.label}
              checked={selectedColumnIds.includes(col.id)}
              onChange={() => handleColumnSelection(col.id)}
              title={col.label} // Shows the full name on hover if it gets truncated
              style={{
                color: "#2B3674",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                margin: 0,
                whiteSpace: "nowrap",    // Keeps the checkbox and text on the same line
                overflow: "hidden",      // Safely hides extra-long column names
                textOverflow: "ellipsis" // Adds "..." if text is too long for the mobile grid
              }}
            />
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )}
</div>


    
<TableContainer 
  component={Paper} 
  elevation={0} // Removes default Paper shadow to use our custom one
  sx={{ 
    marginTop: "20px", 
    borderRadius: "12px", 
    border: "1px solid #E0E5F2", 
    overflowX: "auto", // CRITICAL: Enables horizontal swiping on mobile devices
    backgroundColor: "#ffffff",
    boxShadow: "0px 4px 15px rgba(0,0,0,0.02)",
    // Custom slim scrollbar for a native app feel
    '&::-webkit-scrollbar': { height: '6px' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
  }}
>
  <Table sx={{ minWidth: 800 }} stickyHeader aria-label="premium dynamic table" id="table-to-xls">
    
    <TableHead>
      <TableRow>
        {selectedColumns
          .filter(col => col.isVisible)
          .map((col, index) => (
            <TableCell 
              key={index} 
              align="start" 
              sx={{ 
                background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)", // Placed directly on the cell for stickyHeader compatibility
                minWidth: col.width || 120, // Fallback width
                color: "#ffffff", 
                fontWeight: "700", 
                fontSize: "13px", 
                padding: "16px",
                borderBottom: "1px solid #E0E5F2",
                whiteSpace: "nowrap", // Prevents headers from stacking vertically
                zIndex: 2 // Keeps the gradient header firmly above the scrolling data
              }}
            >
              {col.label}
            </TableCell>
          ))}
      </TableRow>
    </TableHead>

    <TableBody>
      {combinedData
        .filter(row => 
          selectedColumns.some(col => 
            col.isVisible && row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase())
          )
        )
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => (
          <TableRow hover key={index}>
            {selectedColumns
              .filter(col => col.isVisible)
              .map((col, idx) => (
                <TableCell 
                  key={idx} 
                  align="start" 
                  sx={{ 
                    fontSize: "13px", 
                    fontWeight: idx === 0 ? "700" : "500", // Makes the first visible column bold for readability
                    color: idx === 0 ? "#2B3674" : "#707eae", // Darker primary text, softer secondary text
                    minWidth: col.width,
                    padding: "14px 16px",
                    borderBottom: "1px solid #E0E5F2",
                    whiteSpace: "nowrap" // Keeps data looking clean and uniform in one line
                  }}
                >
                  {row[col.id] || "—"} {/* Adds a sleek dash if the data is empty or null */}
                </TableCell>
              ))}
          </TableRow>
        ))}

        {/* Premium Empty State if the search filter returns no results */}
        {combinedData.filter(row => 
          selectedColumns.some(col => 
            col.isVisible && row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase())
          )
        ).length === 0 && (
          <TableRow>
            <TableCell 
              colSpan={selectedColumns.filter(c => c.isVisible).length} 
              align="center" 
              sx={{ padding: "40px" }}
            >
              <Typography sx={{ color: "#A3AED0", fontWeight: "600", fontSize: "14px" }}>
                No records found matching your filter.
              </Typography>
            </TableCell>
          </TableRow>
        )}
    </TableBody>

  </Table>
</TableContainer>


      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={combinedData
          .filter((row) =>
            selectedColumns
              .filter((col) => col.isVisible)
              .some((col) => row[col.id]?.toString().toLowerCase().includes(filterInput.toLowerCase()))
          ).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <div className="d-flex flex-row align-items-center">
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="download-table-xls-button"
          table="table-to-xls"
          filename="tablexls"
          sheet="tablexls"
          buttonText="Excel"
          style={{ display: 'none' }} // Hide default button
        />
        <Button
          variant="contained"
          color="primary"
          size="large"
          style={{ marginLeft: '2rem', height: '50px' }}
          onClick={downloadPDF}
        >
          PDF
        </Button>
      </div>
    </>
  );
};

export default SalesReport;
